import React, { Component } from 'react';

import { FromCreateOrder, InfoContact, WidgetSwipe } from '../../widgets';

import { fetchData } from '../../lib/apis';
import { Spin, Drawer, message } from 'antd';
import config from '../../lib/config';

export default class InfoContactView extends Component{
  constructor(props){
    super(props);
    this.state = {
        reload: false,
        list_tags: [],
        active_tab: 1,
        isOrderDrawerOpen: false,
        orderDrawerMode: 'create',
        selectedOrderDetail: null,
        orderDrawerLoadingDetail: false,
        orderFormSession: 0,
        orderListRefreshToken: 0,
        Provinces: [],
        Districts: [],
        Communes: [],
        loading: false,
    }
    this.getCity = this.getCity.bind(this);
  }
  componentWillMount(){
    this.getCity();
  }
  componentDidMount(){
    if (!this.state.Provinces || this.state.Provinces.length === 0) {
        this.getCity();
    }
  }
  componentWillUnmount(){

  }
  componentDidUpdate(prevProps, prevState){

  }
  componentWillReceiveProps(nextProps){
    if(nextProps.contactInfoSelected && !this.props.contactInfoSelected){
        this.setState({
            active_tab: 1,
            isOrderDrawerOpen: false,
            orderDrawerMode: 'create',
            selectedOrderDetail: null,
            orderDrawerLoadingDetail: false,
            orderFormSession: 0
        })
    }
    if (
        nextProps.contactInfoSelected &&
        this.props.contactInfoSelected &&
        nextProps.contactInfoSelected.contact_id !== this.props.contactInfoSelected.contact_id
    ) {
        this.setState({
            active_tab: 1,
            isOrderDrawerOpen: false,
            orderDrawerMode: 'create',
            selectedOrderDetail: null,
            orderDrawerLoadingDetail: false,
            orderFormSession: 0
        })
    }
  }
  getCity = async (type = 'provinces', parent_id = 0) => {
    try {
        let res = await fetchData({url: `api/v2/geo/${type}?parent_id=${parent_id}`});
        let data = {};
        if(type == 'provinces') {
            data['Provinces'] = res.data;
        } else if (type == 'districts') {
            data['Districts'] = res.data;
        } else if (type == 'communes') {
            data['Communes'] = res.data;
        }
        this.setState(data);
    } catch (err) {

    }
  }

  closeInfoPanel = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const { pathname, search } = this.props.history.location;
    this.props.history.replace(`${pathname}${search || ''}`);
  }

  openOrderDrawer = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState({
      isOrderDrawerOpen: true,
      orderDrawerMode: 'create',
      selectedOrderDetail: null,
      orderDrawerLoadingDetail: false,
      orderFormSession: this.state.orderFormSession + 1
    });
  }

  openOrderDetailDrawer = async (order) => {
    if (!order || !order._id) return;

    this.setState({
      isOrderDrawerOpen: true,
      orderDrawerMode: 'detail',
      selectedOrderDetail: null,
      orderDrawerLoadingDetail: true
    });

    try {
      const response = await fetchData({
        url: `api/v1/orders-v2/${order._id}`
      });

      this.setState({
        selectedOrderDetail: response && response.data ? response.data : order,
        orderDrawerLoadingDetail: false
      });
    } catch (err) {
      this.setState({
        selectedOrderDetail: order,
        orderDrawerLoadingDetail: false
      });
      message.error(err.message || 'Không thể tải chi tiết đơn hàng');
    }
  }

  closeOrderDrawer = () => {
    this.setState({
      isOrderDrawerOpen: false,
      orderDrawerMode: 'create',
      selectedOrderDetail: null,
      orderDrawerLoadingDetail: false
    });
  }

  handleOrderConfirmed = (order) => {
    const confirmedTag = order && order.customer_tag ? order.customer_tag : null;
    if (confirmedTag && this.props.contactInfoSelected && this.props.handleContactInfoSelected) {
      const currentTags = Array.isArray(this.props.contactInfoSelected.tags) ? this.props.contactInfoSelected.tags : [];
      const hasTag = currentTags.some((tag) => `${tag.tag_id}` === `${confirmedTag.tag_id}`);
      const nextContact = hasTag ? this.props.contactInfoSelected : {
        ...this.props.contactInfoSelected,
        tags: currentTags.concat([confirmedTag])
      };
      this.props.handleContactInfoSelected(nextContact);
    }

    this.setState((prevState) => ({
      isOrderDrawerOpen: false,
      orderDrawerMode: 'create',
      selectedOrderDetail: null,
      orderListRefreshToken: prevState.orderListRefreshToken + 1
    }));
  }

  handleOrderSaved = () => {
    this.setState((prevState) => ({
      orderListRefreshToken: prevState.orderListRefreshToken + 1
    }));
  }

  renderOrderDrawer = () => {
    if (!this.props.contactInfoSelected) return null;

    const drawerWidth = this.props.deviceType == 'iOS' || this.props.deviceType == 'Android' ? '100%' : 620;
    const isDetailMode = this.state.orderDrawerMode === 'detail';
    const isLoadingDetail = isDetailMode && this.state.orderDrawerLoadingDetail;

    return (
      <Drawer
        title={isDetailMode ? 'Chi tiết đơn' : 'Tạo đơn'}
        placement="right"
        width={drawerWidth}
        onClose={this.closeOrderDrawer}
        visible={this.state.isOrderDrawerOpen}
        className="chat-order-drawer"
        destroyOnClose={false}
      >
        {isLoadingDetail ? (
          <div style={{ minHeight: 240, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spin spinning={true} />
          </div>
        ) : (
          <FromCreateOrder
            Provinces={this.state.Provinces}
            Districts={this.state.Districts}
            Communes={this.state.Communes}
            getCity={this.getCity}
            contactInfoSelected={this.props.contactInfoSelected}
            isPostFaceData={true}
            orderDetail={this.state.selectedOrderDetail}
            orderMode={this.state.orderDrawerMode}
            orderFormSession={this.state.orderFormSession}
            hydrateCreateOrderFromDraft={false}
            onOrderSaved={this.handleOrderSaved}
            onOrderConfirmed={this.handleOrderConfirmed}
          />
        )}
      </Drawer>
    );
  }

  render(){
    let html = null;
    const contact = this.props.contactInfoSelected;
    const displayName = contact ? ((contact.from && contact.from.full_name_other) || contact.thread_title || contact.full_name || 'Khách hàng') : 'Khách hàng';
    const sourceLabel = contact
      ? (contact.type == 'callcenter'
        ? 'Callcenter'
        : ((contact.type == 'www' || contact.type == 'webchat')
          ? 'Website'
          : ((contact.channel && config.type_account_social[contact.channel.acc_type] && config.type_account_social[contact.channel.acc_type].name)
            || (contact.channel && contact.channel.full_name)
            || 'Kênh chat')))
      : 'Kênh chat';

    if(this.props.contactInfoSelected){
        html = <InfoContact
            {...this.props}
            showFormBooking={this.showFormBooking}
            orderListRefreshToken={this.state.orderListRefreshToken}
            onOrderConfirmed={this.handleOrderConfirmed}
            onOpenOrderDetail={this.openOrderDetailDrawer}
        />;
    }
    return(
        <div id="info-view" className={this.props.history.location.hash == "#info" ? "show" : ""}>
            
            {
                this.props.history.location.hash == "#info" && <WidgetSwipe id="box-touch-right" event="swipeleft" action={this.openOrderDrawer} visible={this.props.deviceType == "iOS"}/>
            }

            <div className="top-bar-app" style={{paddingTop: `${this.props.statusBarHeight}px`}}></div>
            
            {/* <div className="btn-close border-bottom">
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#message-view #info-view').classList.remove("show");
                }}><i className="fal fa-arrow-left"></i> Quay lại</a>
            </div> */}

            <div id="info-caption-panel" className="info-panel-caption">
               
                <div
                    className={this.state.active_tab == 1 ? 'info-panel-caption__copy is-active' : 'info-panel-caption__copy'}
                    onClick={() => this.setState({ active_tab: 1 })}
                >
                    <strong className="info-panel-caption__title">Thông tin</strong>
                </div>
                <button
                    type="button"
                    className={this.state.isOrderDrawerOpen ? 'info-panel-caption__action is-active' : 'info-panel-caption__action'}
                    onClick={this.openOrderDrawer}
                >
                    Tạo đơn
                </button>
            </div>
            {this.renderOrderDrawer()}
            {
                !this.props.contactInfoSelected ?
                <div style={{minHeight: "100%", paddingTop: "50px", textAlign: "center"}}><Spin spinning={true}></Spin></div>
                : html
            }
        </div>
    )
  }
}
